const Passkeys = () => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_538_22141)">
      <path
        d="M24 0H8C3.58172 0 0 3.58172 0 8V24C0 28.4183 3.58172 32 8 32H24C28.4183 32 32 28.4183 32 24V8C32 3.58172 28.4183 0 24 0Z"
        fill="black"
      />
      <path
        d="M25.0271 10.737L21.2901 7L16.4098 11.8803L15.9968 12.2933L14.4044 13.8857L13.591 14.6991L7.03516 21.2549L8.62757 22.8473L9.23941 22.2355L11.478 24.4804L13.0713 22.888L10.8291 20.6449L11.441 20.0339L13.6832 22.2807L15.2738 20.6837L13.0316 18.4406L15.1834 16.2933L15.9968 15.4799L17.7871 13.6896L18.201 13.2748L20.3465 15.4203C20.9673 16.0409 21.8093 16.3896 22.6871 16.3895C23.565 16.3894 24.4068 16.0406 25.0275 15.4198C25.6482 14.799 25.9969 13.9571 25.9968 13.0792C25.9967 12.2014 25.6479 11.3595 25.0271 10.7388V10.737ZM23.4663 13.8577C23.255 14.0686 22.9686 14.1871 22.6701 14.1871C22.3715 14.1871 22.0852 14.0686 21.8739 13.8577L19.7455 11.7293L20.4848 10.9901L21.338 10.1369L23.4663 12.2653C23.6772 12.4766 23.7957 12.7629 23.7957 13.0615C23.7957 13.36 23.6772 13.6464 23.4663 13.8577Z"
        fill="url(#paint0_linear_538_22141)"
      />
      <path
        d="M11.6499 15.4176L12.711 14.3575L15.3879 11.6805L10.7064 7L6.96941 10.737C6.66207 11.0443 6.41827 11.4092 6.25194 11.8107C6.08561 12.2123 6 12.6427 6 13.0773C6 13.5119 6.08561 13.9423 6.25194 14.3438C6.41827 14.7454 6.66207 15.1102 6.96941 15.4176C7.27673 15.7249 7.64158 15.9687 8.04313 16.135C8.44467 16.3014 8.87505 16.387 9.30968 16.387C9.74431 16.387 10.1747 16.3014 10.5762 16.135C10.9778 15.9687 11.3426 15.7249 11.6499 15.4176ZM8.53019 12.2644L10.6585 10.136L11.8786 11.357L12.2509 11.7284L10.1253 13.8568C9.91335 14.0641 9.62818 14.1794 9.33172 14.1777C9.03525 14.1761 8.75139 14.0576 8.54175 13.8479C8.33211 13.6383 8.21361 13.3544 8.21195 13.058C8.21029 12.7615 8.32562 12.4763 8.5329 12.2644H8.53019Z"
        fill="url(#paint1_linear_538_22141)"
      />
      <path
        d="M10.7576 10.039L10.66 9.94141L10.5624 10.039L8.43406 12.1674C8.3081 12.2827 8.2068 12.4224 8.13628 12.578C8.06576 12.7336 8.02748 12.9019 8.02374 13.0726C8.02 13.2434 8.05088 13.4132 8.11452 13.5717C8.17816 13.7302 8.27324 13.8742 8.39402 13.995C8.51481 14.1158 8.65881 14.2109 8.81733 14.2745C8.97585 14.3381 9.14562 14.369 9.3164 14.3653C9.48718 14.3615 9.65543 14.3233 9.81102 14.2527C9.9666 14.1822 10.1063 14.0809 10.2217 13.955L12.35 11.8266L12.4476 11.729L12.35 11.6314L11.6098 10.894L10.7576 10.039ZM10.125 13.8574C9.91301 14.0647 9.62785 14.18 9.33138 14.1783C9.03491 14.1767 8.75105 14.0582 8.54142 13.8485C8.33178 13.6389 8.21327 13.355 8.21161 13.0586C8.20996 12.7621 8.32528 12.4769 8.53257 12.265L10.6609 10.1366L11.515 10.9907L12.2533 11.729L10.125 13.8574Z"
        fill="url(#paint2_linear_538_22141)"
      />
      <path
        d="M22.6758 14.3276C22.9254 14.3269 23.1692 14.2524 23.3766 14.1135C23.584 13.9745 23.7456 13.7773 23.8411 13.5467C23.9367 13.3161 23.9619 13.0623 23.9136 12.8174C23.8652 12.5725 23.7456 12.3474 23.5696 12.1704L21.4412 10.042L21.3436 9.94443L21.2442 10.0393L20.0241 11.2594L19.6518 11.6317L19.5542 11.7293L19.6518 11.8269L21.7865 13.9553C21.9028 14.0729 22.0413 14.1663 22.1939 14.2302C22.3466 14.2941 22.5103 14.3272 22.6758 14.3276ZM20.1236 11.357L21.3436 10.1369L23.472 12.2653C23.5765 12.37 23.6594 12.4943 23.716 12.6311C23.7725 12.7679 23.8015 12.9144 23.8014 13.0624C23.8012 13.2104 23.772 13.3569 23.7152 13.4936C23.6585 13.6303 23.5753 13.7545 23.4706 13.859C23.3659 13.9636 23.2416 14.0465 23.1048 14.103C22.968 14.1595 22.8214 14.1886 22.6734 14.1884C22.5255 14.1883 22.3789 14.159 22.2422 14.1023C22.1056 14.0455 21.9814 13.9624 21.8768 13.8577L19.7485 11.7293L20.1236 11.357ZM25.0327 15.4185C24.4118 16.0387 23.5701 16.3871 22.6925 16.3871C21.8148 16.3871 20.9731 16.0387 20.3522 15.4185L18.2067 13.2729L18.1443 13.3353L17.6925 13.7872L13.0363 18.4433L12.9387 18.3457L17.6925 13.592L18.1064 13.1772L18.204 13.0795L18.3025 13.1772L20.4498 15.3218C20.7443 15.6163 21.094 15.8499 21.4788 16.0093C21.8636 16.1687 22.276 16.2507 22.6925 16.2507C23.109 16.2507 23.5214 16.1687 23.9062 16.0093C24.291 15.8499 24.6406 15.6163 24.9351 15.3218C25.2297 15.0272 25.4633 14.6776 25.6227 14.2928C25.7821 13.908 25.8641 13.4956 25.8641 13.0791C25.8641 12.6626 25.7821 12.2502 25.6227 11.8654C25.4633 11.4806 25.2297 11.1309 24.9351 10.8364L21.2957 7.19702L16.5149 11.9779L16.1001 12.3927L13.0273 15.4655L12.9297 15.3679L16.0024 12.2951L16.4173 11.8803L21.2975 7L25.0346 10.737C25.6549 11.3582 26.0031 12.2003 26.0028 13.0781C26.0024 13.956 25.6535 14.7978 25.0327 15.4185Z"
        fill="url(#paint3_linear_538_22141)"
      />
      <path
        d="M13.6969 13.1774L11.5523 15.3239C11.2578 15.6184 10.9082 15.852 10.5234 16.0114C10.1386 16.1708 9.72614 16.2528 9.30964 16.2528C8.89314 16.2528 8.48072 16.1708 8.09592 16.0114C7.71112 15.852 7.36149 15.6184 7.06698 15.3239C6.77247 15.0293 6.53885 14.6797 6.37946 14.2949C6.22007 13.9101 6.13803 13.4977 6.13803 13.0812C6.13803 12.6647 6.22007 12.2523 6.37946 11.8675C6.53885 11.4827 6.77247 11.133 7.06698 10.8385L9.07783 8.82768L10.804 7.10151L10.7064 7.00391L6.96937 10.7409C6.66204 11.0483 6.41826 11.4131 6.25193 11.8146C6.08561 12.2162 6 12.6466 6 13.0812C6 13.5158 6.08561 13.9462 6.25193 14.3477C6.41826 14.7493 6.66204 15.1141 6.96937 15.4215C7.2767 15.7288 7.64155 15.9726 8.0431 16.1389C8.44464 16.3052 8.87501 16.3908 9.30964 16.3908C9.74427 16.3908 10.1746 16.3052 10.5762 16.1389C10.9777 15.9726 11.3426 15.7288 11.6499 15.4215L13.536 13.5353L15.3878 11.6844L15.2893 11.5868L13.6969 13.1774Z"
        fill="url(#paint4_linear_538_22141)"
      />
      <path
        d="M13.9912 14.3057L7.03516 21.2617L7.13293 21.3595L14.089 14.4034L13.9912 14.3057Z"
        fill="url(#paint5_linear_538_22141)"
      />
      <path
        d="M16.6094 16.0894L18.2018 14.4961L24.9628 21.2562L23.3704 22.8486L22.7585 22.2376L20.5154 24.4799L18.923 22.8874L21.1661 20.6452L20.5543 20.0334L18.312 22.2756L16.7196 20.6832L18.9618 18.441L16.6094 16.0894Z"
        fill="url(#paint6_linear_538_22141)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_538_22141"
        x1="25.1075"
        y1="9.25938"
        x2="13.3036"
        y2="21.0642"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.07" stopColor="#B1E4DE" />
        <stop offset="0.22" stopColor="#4CB7A3" />
        <stop offset="0.4" stopColor="#468DC0" />
        <stop offset="0.65" stopColor="#3F59E4" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_538_22141"
        x1="16.5176"
        y1="5.87031"
        x2="7.809"
        y2="14.5789"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.07" stopColor="#B1E4DE" />
        <stop offset="0.22" stopColor="#4CB7A3" />
        <stop offset="0.4" stopColor="#468DC0" />
        <stop offset="0.65" stopColor="#3F59E4" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_538_22141"
        x1="7.78968"
        y1="14.5975"
        x2="9.83849"
        y2="12.5487"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" stopColor="#3F59E4" />
        <stop offset="0.54" stopColor="#4CB7A3" />
        <stop offset="1" stopColor="#3F59E4" />
      </linearGradient>
      <linearGradient
        id="paint3_linear_538_22141"
        x1="24.6215"
        y1="9.75102"
        x2="17.3246"
        y2="17.0488"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.32" stopColor="#B1E4DE" />
        <stop offset="0.72" stopColor="#3F59E4" />
      </linearGradient>
      <linearGradient
        id="paint4_linear_538_22141"
        x1="7.21067"
        y1="15.1784"
        x2="10.4036"
        y2="11.9854"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" stopColor="#3F59E4" />
        <stop offset="0.54" stopColor="#4CB7A3" />
        <stop offset="1" stopColor="#3F59E4" />
      </linearGradient>
      <linearGradient
        id="paint5_linear_538_22141"
        x1="6.84038"
        y1="17.8318"
        x2="13.3619"
        y2="17.8318"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.15" stopColor="#3F59E4" />
        <stop offset="0.54" stopColor="#4CB7A3" />
        <stop offset="1" stopColor="#3F59E4" />
      </linearGradient>
      <linearGradient
        id="paint6_linear_538_22141"
        x1="25.8331"
        y1="13.6258"
        x2="17.3414"
        y2="22.1165"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.07" stopColor="#B1E4DE" />
        <stop offset="0.22" stopColor="#4CB7A3" />
        <stop offset="0.4" stopColor="#468DC0" />
        <stop offset="0.65" stopColor="#3F59E4" />
      </linearGradient>
      <clipPath id="clip0_538_22141">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export default Passkeys;
